<template>
  <footer
    class="
      w-full
      p-2
      flex
      sm:flex-row
      flex-col
      justify-center
      bg-footerBackground-light
      dark:bg-footerBackground-dark
      transition-all
      duration-300
    "
  >
    <p
      class="
        sm:mr-1.5
        mr-0
        text-sm
        sm:text-base
        font-normal font-josefin
        text-footerText-light
        dark:text-footerText-dark
        text-center
      "
    >
      Challenge by
      <a
        class="text-footerLink-light dark:text-footerLink-dark hover:underline"
        href="https://www.frontendmentor.io?ref=challenge"
        target="_blank"
        rel="noopener"
        >Frontend Mentor</a
      >.
    </p>
    <p
      class="
        text-sm
        sm:text-base
        font-normal font-josefin
        text-footerText-light
        dark:text-footerText-dark
        text-center
      "
    >
      Coded by
      <a
        class="text-footerLink-light dark:text-footerLink-dark hover:underline"
        href="https://www.frontendmentor.io/profile/MrGeminus"
        target="_blank"
        rel="noopener"
        >Uros Tomic</a
      >.
    </p>
  </footer>
</template>
<script>
export default {
  name: "Footer",
};
</script>
